/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./standard-layout.vue.js?vue&type=template&id=d83e809c!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./standard-layout.vue?vue&type=template&id=d83e809c"
import script from "./standard-layout.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./standard-layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./standard-layout.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./standard-layout.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./standard-layout.vue.postcss?vue&type=style&index=0&id=d83e809c&prod&lang=postcss&module=true!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./standard-layout.vue?vue&type=style&index=0&id=d83e809c&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports